import { motion } from 'motion/react';
import { MANUAL_CONTENT } from '../constants';
import { BookOpen, ArrowRight, Shield, Zap, Anchor, Info, FileText, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Manual() {
  const icons = [Anchor, Shield, Zap, Info];

  return (
    <section className="py-24 bg-baja-sand relative overflow-hidden min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link 
          to="/" 
          className="inline-flex items-center gap-3 text-ows-teal text-[10px] font-bold tracking-[0.4em] uppercase mb-16 hover:text-ows-dark transition-colors group"
        >
          <ArrowLeft className="h-4 w-4 group-hover:-translate-x-2 transition-transform" />
          Back to Home
        </Link>
        <div className="flex flex-col md:flex-row items-end justify-between mb-16 gap-8">
          <div className="max-w-2xl">
            <div className="flex items-center gap-2 text-deep-sea-teal mb-4">
              <BookOpen className="h-5 w-5" />
              <span className="text-xs font-bold tracking-[0.3em] uppercase text-deep-sea-teal">Engineering Field Guide</span>
            </div>
            <h2 className="ows-header">
              The OWS <br />
              <span className="text-ows-dark/40">Technical Manual.</span>
            </h2>
          </div>
          <p className="text-black/60 max-w-sm font-medium tracking-tight leading-relaxed">
            Technical data, survival protocols, and hardware schematics. This is the OWS knowledge base for the amphibious life.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {MANUAL_CONTENT.map((item, index) => {
            const Icon = icons[index % icons.length];
            return (
              <motion.div 
                key={item.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-10 group hover:shadow-xl transition-all cursor-pointer relative border border-black/5 baja-shadow"
              >
                <div className="relative z-10" id={item.id}>
                  <div className="text-[10px] font-mono font-bold text-deep-sea-teal mb-6 tracking-widest uppercase">
                    Technical Report 00{index + 1}
                  </div>
                  <h3 className="text-2xl font-bold tracking-tighter uppercase mb-4 text-black group-hover:text-safety-orange transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-black/60 font-medium tracking-tight mb-8 text-sm leading-relaxed">
                    {item.subtitle}
                  </p>
                  <ul className="space-y-4 mb-10">
                    {item.points.map((point, i) => (
                      <li key={`${item.id}-point-${i}`} className="flex items-start gap-3 text-sm text-black/80 font-medium tracking-tight">
                        <div className="h-1.5 w-1.5 bg-safety-orange rounded-full mt-1.5 flex-shrink-0"></div>
                        {point}
                      </li>
                    ))}
                  </ul>
                  <button className="flex items-center gap-2 text-[10px] font-bold tracking-widest uppercase text-deep-sea-teal group-hover:text-safety-orange transition-colors">
                    Download Full PDF
                    <ArrowRight className="h-3 w-3" />
                  </button>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
